import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
  clearStructureHistory,
  structureRedo,
  structureUndo
} from 'features/structure';
import { useCallback, useEffect } from 'react';

export function useStructureHistory(enabled: boolean) {
  const dispatch = useAppDispatch();
  const { canUndo, canRedo } = useAppSelector(
    (state) => state.structureHistory
  );

  const undo = useCallback(() => {
    dispatch(structureUndo());
  }, [dispatch]);

  const redo = useCallback(() => {
    dispatch(structureRedo());
  }, [dispatch]);

  const clear = useCallback(() => {
    dispatch(clearStructureHistory());
  }, [dispatch]);

  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      const isInput =
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.tagName === 'SELECT' ||
        target.isContentEditable;
      if (isInput) return;

      const isCtrlOrCmd = e.ctrlKey || e.metaKey;
      if (!isCtrlOrCmd) return;

      if (e.key === 'z' && !e.shiftKey) {
        e.preventDefault();
        dispatch(structureUndo());
      } else if ((e.key === 'z' && e.shiftKey) || e.key === 'y') {
        e.preventDefault();
        dispatch(structureRedo());
      }
    };

    globalThis.addEventListener('keydown', handleKeyDown);

    // eslint-disable-next-line consistent-return
    return () => {
      globalThis.removeEventListener('keydown', handleKeyDown);
    };
  }, [enabled, dispatch]);

  return { undo, redo, canUndo, canRedo, clear };
}
